import { SupportedLanguage, SupportedReligion } from '@/enum'
import { HeaderText } from '@/types'

export const HEADER_TEXT_OPTIONS: HeaderText[] = [
  {
    id: '001',
    text: '|| श्री गणेशाय नम: ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Hindi, SupportedLanguage.English, SupportedLanguage.Marathi],
  },
  {
    id: '002',
    text: '|| ॐ  श्रीकृष्णाय नमः ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Hindi, SupportedLanguage.English, SupportedLanguage.Marathi],
  },
  {
    id: '102',
    text: '|| ॐ नमः शिवाय: ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Hindi, SupportedLanguage.English, SupportedLanguage.Marathi],
  },
  {
    id: '103',
    text: '|| हर हर महादेव: ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Hindi, SupportedLanguage.English, SupportedLanguage.Marathi],
  },
  {
    id: '015',
    text: '|| શ્રી ગણેશાય નમઃ ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Gujarati],
  },
  {
    id: '016',
    text: '|| শ্রী শ্রী গণেশায় নমঃ ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Bengali],
  },
  {
    id: '017',
    text: '|| శ్రీ గణేశాయ నమ: ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Telugu],
  },
  {
    id: '021',
    text: '|| ಓಂ ಶ್ರೀ ಗಣೇಶಯ್ಯ ನಮಃ ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Kannada],
  },
  {
    id: '022',
    text: '|| ಓಂ ಶ್ರೀಕೃಷ್ಣಾಯ ನಮಃ ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Kannada],
  },
  {
    id: '029',
    text: '|| ಶ್ರೀ ಗುರುಭ್ಯೋ ನಮ: ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Kannada],
  },
  {
    id: '030',
    text: '|| ಓಂ ನಮಃ ಶಿವಾಯ ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Kannada],
  },
  {
    id: '031',
    text: '|| ಓಂ ಶ್ರೀ ರಾಮ ಜಯ ರಾಮ ಜಯ ಜಯ ರಾಮ ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Kannada],
  },
  {
    id: '032',
    text: '|| ಶ್ರೀ ಚಕ್ರೇಶ್ವರಿ ಮಾತೆಗೆ ನಮಃ ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Kannada],
  },
  {
    id: '033',
    text: '|| ஸ்ரீ கணேஷாய நம: ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Tamil],
  },
  {
    id: '035',
    text: 'ஸ்ரீமதேய ராமஜெயம்',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Tamil],
  },
  {
    id: '034',
    text: 'ஓம் சக்தி',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Tamil],
  },
  {
    id: '0341',
    text: 'ஸ்ரீ சிவாய நம:',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Tamil],
  },
  {
    id: '003',
    text: '|| नमो बुध्दाय ||',
    religion: SupportedReligion.Buddhism,
    locale: [SupportedLanguage.Hindi, SupportedLanguage.English, SupportedLanguage.Marathi],
  },
  {
    id: '004',
    text: '|| बुद्धं शरणं गच्छामि ||',
    religion: SupportedReligion.Buddhism,
    locale: [SupportedLanguage.Hindi, SupportedLanguage.English, SupportedLanguage.Marathi],
  },
  {
    id: '005',
    text: '|| जय भीम ||',
    religion: SupportedReligion.Buddhism,
    locale: [SupportedLanguage.Hindi, SupportedLanguage.English, SupportedLanguage.Marathi],
  },
  {
    id: '006',
    text: '|| नमो बुध्दाय ||  || नमो भिमाय ||',
    religion: SupportedReligion.Buddhism,
    locale: [SupportedLanguage.Hindi, SupportedLanguage.English, SupportedLanguage.Marathi],
  },
  {
    id: '0061',
    text: '|| नमो बुध्दाय ||  || जय भीम ||',
    religion: SupportedReligion.Buddhism,
    locale: [SupportedLanguage.Hindi, SupportedLanguage.English, SupportedLanguage.Marathi],
  },
  {
    id: '007',
    text: '|| श्री महावीराय नम: ||',
    religion: SupportedReligion.Jainism,
    locale: [SupportedLanguage.Hindi, SupportedLanguage.English, SupportedLanguage.Marathi],
  },
  {
    id: '106',
    text: '|| ॐ नमः सिद्धेभ्यः ||',
    religion: SupportedReligion.Jainism,
    locale: [SupportedLanguage.Hindi, SupportedLanguage.English, SupportedLanguage.Marathi],
  },
  {
    id: '008',
    text: '|| जय जिनेन्द्र ||',
    religion: SupportedReligion.Jainism,
    locale: [SupportedLanguage.Hindi, SupportedLanguage.English, SupportedLanguage.Marathi],
  },

  {
    id: '023',
    text: '|| ಜಯ ಜಿನೇಂದ್ರ ||',
    religion: SupportedReligion.Jainism,
    locale: [SupportedLanguage.Kannada],
  },
  {
    id: '014',
    text: 'IN THE NAME OF ALLAH',
    religion: SupportedReligion.Islam,
    locale: [
      SupportedLanguage.Hindi,
      SupportedLanguage.English,
      SupportedLanguage.Marathi,
      SupportedLanguage.Malayalam,
      SupportedLanguage.Odia,
      SupportedLanguage.Telugu,
      SupportedLanguage.Kannada,
      SupportedLanguage.Bengali,
      SupportedLanguage.Gujarati,
    ],
  },
  {
    id: '036',
    text: 'அல்லாஹ்வின் நாமத்தில்',
    religion: SupportedReligion.Islam,
    locale: [SupportedLanguage.Tamil],
  },
  {
    id: '037',
    text: 'அஸ்ஸலாமு அலைக்கும் வரஹ்மத்துல்லாஹி வபரக்காத்துஹு',
    religion: SupportedReligion.Islam,
    locale: [SupportedLanguage.Tamil],
  },
  {
    id: '020',
    text: 'আল্লাহর নামে',
    religion: SupportedReligion.Islam,
    locale: [SupportedLanguage.Bengali],
  },
  {
    id: '018',
    text: 'అల్లాహ్ పేరుతో',
    religion: SupportedReligion.Islam,
    locale: [SupportedLanguage.Telugu],
  },
  {
    id: '019',
    text: 'అస్సలాము అలైకుం వ రహమతుల్లాహి వ బరకాతుహు',
    religion: SupportedReligion.Islam,
    locale: [SupportedLanguage.Telugu],
  },
  {
    id: '0141',
    text: 'Assalamu Alaikum Wa Rahmatullahi Wa Barakatuh',
    religion: SupportedReligion.Islam,
    locale: [SupportedLanguage.Hindi, SupportedLanguage.English, SupportedLanguage.Marathi],
  },
  {
    id: '024',
    text: 'ಅಲ್ಲಾಹನ ಹೆಸರಿನಲ್ಲಿ',
    religion: SupportedReligion.Islam,
    locale: [SupportedLanguage.Kannada],
  },
  {
    id: '025',
    text: 'ಅಸ್ಸಲಾಮು ಅಲೈಕುಂ ವಾ ರಹ್ಮತುಲ್ಲಾಹಿ ವಾ ಬರಕಾತುಹು',
    religion: SupportedReligion.Islam,
    locale: [SupportedLanguage.Kannada],
  },
  {
    id: '011',
    text: 'Praise the Lord',
    religion: SupportedReligion.Christianity,
    locale: [
      SupportedLanguage.Hindi,
      SupportedLanguage.English,
      SupportedLanguage.Marathi,
      SupportedLanguage.Malayalam,
      SupportedLanguage.Odia,
      SupportedLanguage.Telugu,
      SupportedLanguage.Kannada,
      SupportedLanguage.Bengali,
      SupportedLanguage.Gujarati,
    ],
  },
  {
    id: '013',
    text: "With God's Grace",
    religion: SupportedReligion.Christianity,
    locale: [
      SupportedLanguage.Hindi,
      SupportedLanguage.English,
      SupportedLanguage.Marathi,
      SupportedLanguage.Malayalam,
      SupportedLanguage.Odia,
      SupportedLanguage.Telugu,
      SupportedLanguage.Kannada,
      SupportedLanguage.Bengali,
      SupportedLanguage.Gujarati,
    ],
  },
  {
    id: '0142',
    text: "In Christ's Love",
    religion: SupportedReligion.Christianity,
    locale: [
      SupportedLanguage.Hindi,
      SupportedLanguage.English,
      SupportedLanguage.Marathi,
      SupportedLanguage.Malayalam,
      SupportedLanguage.Odia,
      SupportedLanguage.Telugu,
      SupportedLanguage.Kannada,
      SupportedLanguage.Bengali,
      SupportedLanguage.Gujarati,
    ],
  },

  {
    id: '026',
    text: 'ಪ್ರಭುವಿನ ಸ್ತುತಿ',
    religion: SupportedReligion.Christianity,
    locale: [SupportedLanguage.Kannada],
  },
  {
    id: '027',
    text: 'ದೇವರ ಕೃಪೆಯಿಂದ',
    religion: SupportedReligion.Christianity,
    locale: [SupportedLanguage.Kannada],
  },
  {
    id: '028',
    text: 'ಕ್ರಿಸ್ತನ ಪ್ರೀತಿಯಲ್ಲಿ',
    religion: SupportedReligion.Christianity,
    locale: [SupportedLanguage.Kannada],
  },
  {
    id: '038',
    text: 'கத்தர் வாழ்த்தப்படுவாராக',
    religion: SupportedReligion.Christianity,
    locale: [SupportedLanguage.Tamil],
  },
  {
    id: '039',
    text: 'শ্রী শ্রী দুর্গায় নমঃ',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Bengali],
  },
  {
    id: '040',
    text: 'শ্রী শ্রী কালীয় নমঃ',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Bengali],
  },
  {
    id: '041',
    text: 'জয় মা কালী',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Bengali],
  },
  {
    id: '042',
    text: 'জয় মা দুর্গা',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Bengali],
  },
  {
    id: '043',
    text: 'শুভ দেবী আশীর্বাদ',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Bengali],
  },

  {
    id: '044',
    text: 'বুদ্ধং শরণং গচ্ছামি',
    religion: SupportedReligion.Buddhism,
    locale: [SupportedLanguage.Bengali],
  },
  {
    id: '045',
    text: 'ধর্মং শরণং গচ্ছামি',
    religion: SupportedReligion.Buddhism,
    locale: [SupportedLanguage.Bengali],
  },
  {
    id: '046',
    text: 'সংঘং শরণং গচ্ছামি',
    religion: SupportedReligion.Buddhism,
    locale: [SupportedLanguage.Bengali],
  },
  {
    id: '047',
    text: 'জয় ভীম',
    religion: SupportedReligion.Buddhism,
    locale: [SupportedLanguage.Bengali],
  },
  {
    id: '048',
    text: 'জয় জিনেন্দ্র',
    religion: SupportedReligion.Jainism,
    locale: [SupportedLanguage.Bengali],
  },
  {
    id: '049',
    text: 'ওম নমঃ সিদ্ধিভ্যঃ',
    religion: SupportedReligion.Jainism,
    locale: [SupportedLanguage.Bengali],
  },
  {
    id: '050',
    text: 'প্রভুর প্রশংসা করুন',
    religion: SupportedReligion.Christianity,
    locale: [SupportedLanguage.Bengali],
  },
  {
    id: '051',
    text: 'ঈশ্বরের কৃপায়',
    religion: SupportedReligion.Christianity,
    locale: [SupportedLanguage.Bengali],
  },
  {
    id: '052',
    text: 'খ্রিস্টের প্রেমে',
    religion: SupportedReligion.Christianity,
    locale: [SupportedLanguage.Bengali],
  },
  {
    id: '054',
    text: 'আসসালামু আলাইকুম ওয়া রাহমাতুল্লাহি ওয়া বারাকাতুহু',
    religion: SupportedReligion.Islam,
    locale: [SupportedLanguage.Bengali],
  },

  {
    id: '055',
    text: 'ప్రభువును స్తుతించండి',
    religion: SupportedReligion.Christianity,
    locale: [SupportedLanguage.Telugu],
  },
  {
    id: '056',
    text: 'దేవుని కృపతో',
    religion: SupportedReligion.Christianity,
    locale: [SupportedLanguage.Telugu],
  },
  {
    id: '057',
    text: 'క్రీస్తు ప్రేమలో',
    religion: SupportedReligion.Christianity,
    locale: [SupportedLanguage.Telugu],
  },
  {
    id: '058',
    text: 'శ్రీ వినాయకాయ నమః',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Telugu],
  },
  {
    id: '059',
    text: 'અલ્લાહના નામે',
    religion: SupportedReligion.Islam,
    locale: [SupportedLanguage.Gujarati],
  },
  {
    id: '060',
    text: 'અસ્સલામુ અલૈકુમ વા રહમતુલ્લાહી વા બરકાતુહુ',
    religion: SupportedReligion.Islam,
    locale: [SupportedLanguage.Gujarati],
  },
  {
    id: '061',
    text: 'પ્રભુની પ્રશંસા કરો',
    religion: SupportedReligion.Christianity,
    locale: [SupportedLanguage.Gujarati],
  },
  {
    id: '062',
    text: 'દેવની કૃપાથી',
    religion: SupportedReligion.Christianity,
    locale: [SupportedLanguage.Gujarati],
  },
  {
    id: '063',
    text: 'ખ્રિસ્તના પ્રેમમાં',
    religion: SupportedReligion.Christianity,
    locale: [SupportedLanguage.Gujarati],
  },
  {
    id: '064',
    text: '|| શ્રી કૃષ્ણાય નમઃ ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Gujarati],
  },
  {
    id: '065',
    text: '|| જય શ્રી રામ ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Gujarati],
  },
  {
    id: '066',
    text: '|| ઓમ નમઃ શિવાય ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Gujarati],
  },
  {
    id: '067',
    text: '|| જય હનુમાન ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Gujarati],
  },
  {
    id: '068',
    text: '|| જય માતાજી ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Gujarati],
  },
  {
    id: '069',
    text: '|| જય શ્રી કૃષ્ણ ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Gujarati],
  },
  {
    id: '070',
    text: '|| જય જિનેન્દ્ર ||',
    religion: SupportedReligion.Jainism,
    locale: [SupportedLanguage.Gujarati],
  },
  {
    id: '071',
    text: '|| ॐ श्री जगन्नाथाय नमः ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Hindi, SupportedLanguage.English, SupportedLanguage.Marathi],
  },
  {
    id: '072',
    text: '|| जय श्री राधे ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Hindi, SupportedLanguage.English, SupportedLanguage.Marathi],
  },
  {
    id: '073',
    text: '|| जय श्री कृष्ण ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Hindi, SupportedLanguage.English, SupportedLanguage.Marathi],
  },
  {
    id: '074',
    text: '|| ଶ୍ରୀ ଗଣେଶାୟ ନମଃ ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Odia],
  },
  {
    id: '075',
    text: '|| ଓମ୍ ନମଃ ଶିବାୟ ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Odia],
  },
  {
    id: '076',
    text: '|| ଜୟ ଶ୍ରୀ କୃଷ୍ଣ ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Odia],
  },
  {
    id: '077',
    text: 'ଅଲ୍ଲାହ୍ ନାମରେ',
    religion: SupportedReligion.Islam,
    locale: [SupportedLanguage.Odia],
  },
  {
    id: '078',
    text: 'ଆସସଲାମୁ ଆଲାଇକୁମ୍ ୱା ରହମତୁଲ୍ଲାହି ୱା ବରକାତୁହୁ',
    religion: SupportedReligion.Islam,
    locale: [SupportedLanguage.Odia],
  },
  {
    id: '079',
    text: 'ପ୍ରଭୁଙ୍କୁ ସ୍ତୁତି କରନ୍ତୁ',
    religion: SupportedReligion.Christianity,
    locale: [SupportedLanguage.Odia],
  },
  {
    id: '080',
    text: 'ପ୍ରଭୁଙ୍କ ଦୟାରେ',
    religion: SupportedReligion.Christianity,
    locale: [SupportedLanguage.Odia],
  },
  {
    id: '081',
    text: 'ଖ୍ରୀଷ୍ଟଙ୍କ ପ୍ରେମରେ',
    religion: SupportedReligion.Christianity,
    locale: [SupportedLanguage.Odia],
  },
  {
    id: '082',
    text: 'ବୁଦ୍ଧଂ ଶରଣଂ ଗଚ୍ଛାମି',
    religion: SupportedReligion.Buddhism,
    locale: [SupportedLanguage.Odia],
  },
  {
    id: '083',
    text: 'ଧର୍ମଂ ଶରଣଂ ଗଚ୍ଛାମି',
    religion: SupportedReligion.Buddhism,
    locale: [SupportedLanguage.Odia],
  },
  {
    id: '084',
    text: 'ସଂଘଂ ଶରଣଂ ଗଚ୍ଛାମି',
    religion: SupportedReligion.Buddhism,
    locale: [SupportedLanguage.Odia],
  },
  {
    id: '085',
    text: 'ଜୟ ଭୀମ',
    religion: SupportedReligion.Buddhism,
    locale: [SupportedLanguage.Odia],
  },
  {
    id: '086',
    text: '|| ଓଁ ଶ୍ରୀ ଜଗନ୍ନାଥାୟ ନମଃ ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Odia],
  },
  {
    id: '087',
    text: '|| ଓଁ ଶ୍ରୀ ଚକ୍ରଧରାୟ ନମଃ ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Odia],
  },
  {
    id: '088',
    text: '|| ଜୟ ଜଗନ୍ନାଥ ||',
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Odia],
  },
  {
    id: '089',
    text: '|| ഓം ശ്രീ ഗണേശായ നമഃ ||', // Om Sri Ganesha Namaha
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Malayalam],
  },
  {
    id: '090',
    text: '|| ഓം നമഃ ശിവായ ||', // Om Namah Shivaya
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Malayalam],
  },
  {
    id: '091',
    text: '|| ശ്രീ കൃഷ്ണായ നമഃ ||', // Sri Krishnaya Namaha
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Malayalam],
  },
  {
    id: '092',
    text: '|| ഹരി ശ്രീ ഗൗരി ശങ്കരായ നമഃ ||', // Hari Sri Gauri Shankaraya Namaha
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Malayalam],
  },
  {
    id: '093',
    text: '|| ശ്രീ ഗുരുഭ്യോ നമഃ ||', // Sri Gurubhyo Namaha
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Malayalam],
  },
  {
    id: '094',
    text: '|| ശ്രീ സരസ്വത്യൈ നമഃ ||', // Sri Saraswatyai Namaha
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Malayalam],
  },
  {
    id: '095',
    text: 'യേശുക്രിസ്തുവിന്റെ നാമത്തിൽ', // In the name of Jesus Christ
    religion: SupportedReligion.Christianity,
    locale: [SupportedLanguage.Malayalam],
  },
  {
    id: '096',
    text: 'ദൈവത്തിന്റെ കൃപയാൽ', // By the Grace of God
    religion: SupportedReligion.Christianity,
    locale: [SupportedLanguage.Malayalam],
  },
  {
    id: '097',
    text: 'ബുദ്ധം ശരണം ഗച്ഛാമി', // Buddham Sharanam Gacchami
    religion: SupportedReligion.Buddhism,
    locale: [SupportedLanguage.Malayalam],
  },
  {
    id: '098',
    text: 'ധർമ്മം ശരണം ഗച്ഛാമി', // Dharmam Sharanam Gacchami
    religion: SupportedReligion.Buddhism,
    locale: [SupportedLanguage.Malayalam],
  },
  {
    id: '099',
    text: 'സംഘം ശരണം ഗച്ഛാമി', // Sangham Sharanam Gacchami
    religion: SupportedReligion.Buddhism,
    locale: [SupportedLanguage.Malayalam],
  },
  {
    id: '101',
    text: '|| ശ്രീ ഗുരുവായുരപ്പനു സമർപ്പണം ||', // Dedicated to Sri Guruvayurappan
    religion: SupportedReligion.Hinduism,
    locale: [SupportedLanguage.Malayalam],
  },
  {
    id: '104',
    text: 'Waheguru Ji Ka Khalsa, Waheguru Ji Ki Fateh',
    religion: SupportedReligion.Sikhism,
    locale: [SupportedLanguage.English],
  },
  {
    id: '105',
    text: 'Ik Onkar',
    religion: SupportedReligion.Sikhism,
    locale: [SupportedLanguage.English],
  },
]
